// Gestione eventi per i collapsible tramite event delegation
document.body.addEventListener('click', (event) => {
  const header = event.target.closest('.collapsible');
  if (!header) return;

  header.classList.toggle('active');

  const content = header.nextElementSibling;
  if (!content?.classList.contains('content')) return;

  content.classList.toggle('is-open');
}); 